import { BaseService, DataResponse, STATUS_OK, SuccessResponse } from "@/core/services/BaseService"
import { LoginData, Session } from "@/model/auth.model";
import { AxiosResponse } from "axios";

class AuthService extends BaseService {

  private loggedIn: boolean = false;

  public async login(data: LoginData): Promise<string> {
    return await this.$http
      .post<DataResponse<Session>>(`/api/auth/login`, data)
      .catch(error => error.response)
      .then((res) => this.handleResponse(res));
  }

  public async logout(): Promise<void> {
    return await this.$http
      .get<SuccessResponse>(`/api/auth/logout`)
      .catch(error => error.response)
      .then((res) => {
        this.loggedIn = false;
      });
  }

  public async update() {
    return await this.$http
      .get<DataResponse<Session>>(`/api/auth`)
      .catch(error => error.response)
      .then((res) => this.handleResponse(res));

  }

  public isLoggedIn(): boolean {
    return this.loggedIn
  }

  private handleResponse(res: AxiosResponse<DataResponse<Session>>) {
    this.loggedIn = res.status === STATUS_OK;
    return res.status === STATUS_OK ? res.data.data.uuid : ''
  }
}

export default new AuthService()
